import React from 'react';

import type {
  IntercomProviderProps as BaseIntercomProviderProps,
  IntercomProps,
} from 'react-use-intercom';
import { IntercomProvider as BaseIntercomProvider } from 'react-use-intercom';
import { intercomAppId, isCI } from 'src/config';

interface IntercomProviderProps extends Omit<BaseIntercomProviderProps, 'appId'> {
  children: React.ReactNode;
}

/** Default launcher placement — shared so page-level overrides can restore cleanly. */
export const INTERCOM_LAUNCHER_DEFAULTS = {
  alignment: 'right',
  horizontalPadding: 20,
  verticalPadding: 20,
} satisfies IntercomProps;

export function IntercomProvider({ children, ...rest }: IntercomProviderProps) {
  return (
    <BaseIntercomProvider
      appId={intercomAppId}
      /** Disable Intercom for CI so it doesn't cause Cypress test issues. */
      autoBoot={!isCI}
      autoBootProps={INTERCOM_LAUNCHER_DEFAULTS}
      {...rest}
    >
      {children}
    </BaseIntercomProvider>
  );
}
